<template>
<div>
	<form class="search-form">
		    <div>
			    <div class="title small-title green">Search in Nevvon</div>
			    <div class="d-flex">
				    <div class="input-content flex-fill d-flex">
				    	<input type="text" placeholder="Search..." />
				    </div>
					<input type="submit" class="button m-0" value="Search" />
			    </div>
		    </div>
	    </form>
        <header id="head" class="logged darkgreen-content" v-if="isLogged">
		<div class="container-fluid">
		    <div class="row justify-content-between align-items-center">
			    <div class="col-4 col-lg-5">
				    <div class="trigger-menu" @click="triggerMenu"><i></i><i></i><i></i></div>
			    </div>
			    <div class="col-4 col-lg-2 text-center">
				    <a class="logo">
					    <svg width="200" class="svg-logo" viewBox="0 0 238.1 39.5" enable-background="new 0 0 238.1 39.5" xml:space="preserve">
							<g>
								<g>
									<path fill="#fff" d="M32.4,15.5v20.7c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5V15.5c0-6.7-3.7-10.6-10.3-10.6
										C10,4.8,5,9.3,5,18.8v17.3c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5L0,3.4C0,2,1.1,0.9,2.5,0.9h0C3.9,0.9,5,2,5,3.4v1.2
										C5,5.3,5.8,5.5,6.2,5C9,1.7,12.8,0,17.6,0C26.8,0,32.4,6,32.4,15.5z"></path>
								</g>
								<g>
									<path fill="#ffffff" d="M73,6c3.5,3.9,5.2,8.6,5.2,13.9c0,0,0,0,0,0c0,1.3-1.1,2.3-2.4,2.3l-27.7,0c-1.7,0-2.9,1.6-2.4,3.2
										c2,5.7,7.4,9.2,14.2,9.2c4.8,0,8.7-1.8,11-4.7c0.8-0.9,2.1-1.1,3.1-0.5v0c1.3,0.8,1.6,2.6,0.6,3.8c-3.5,3.9-8.7,6.3-14.8,6.3
										c-6,0-10.8-1.9-14.5-5.6c-3.7-3.7-5.6-8.4-5.6-14.2c0-5.7,1.8-10.3,5.5-14.1C49,1.9,53.7,0,59.5,0C65.1,0,69.6,2,73,6z M48.1,17.4
										H70c1.7,0,2.9-1.6,2.4-3.2c-0.8-2.5-2.1-4.5-3.9-6.1c-2.6-2.2-5.6-3.3-9-3.3c-6.6,0-11.8,3.7-13.8,9.3
										C45.1,15.7,46.4,17.4,48.1,17.4z"></path>
								</g>
								<g>
									<path fill="#ffffff" d="M113.4,0.9L113.4,0.9c1.7,0,2.9,1.8,2.3,3.4l-12.9,31.5c-0.7,1.7-2.3,2.8-4.2,2.8h0
										c-1.8,0-3.5-1.1-4.2-2.8L81.4,4.3c-0.7-1.6,0.5-3.4,2.3-3.4h0c1,0,1.9,0.6,2.3,1.5l10.3,25.4c0.8,2,3.7,2,4.5,0l10.3-25.4
										C111.5,1.5,112.4,0.9,113.4,0.9z"></path>
								</g>
								<g>
									<path fill="#ffffff" d="M151.8,0.9L151.8,0.9c1.7,0,2.9,1.8,2.3,3.4l-12.9,31.5c-0.7,1.7-2.3,2.8-4.2,2.8l0,0
										c-1.8,0-3.5-1.1-4.2-2.8L119.9,4.3c-0.7-1.6,0.5-3.4,2.3-3.4h0c1,0,1.9,0.6,2.3,1.5l10.3,25.4c0.8,2,3.7,2,4.5,0l10.3-25.4
										C149.9,1.5,150.8,0.9,151.8,0.9z"></path>
								</g>
								<g>
									<path fill="#ffffff" d="M177.5,39.5c-5.5,0-10.3-1.9-14.1-5.7c-3.8-3.8-5.7-8.5-5.7-14.1c0-5.6,1.9-10.3,5.7-14
										C167.3,1.9,172,0,177.5,0c5.5,0,10.2,1.9,14,5.7c3.8,3.8,5.8,8.4,5.8,14c0,5.6-2,10.3-5.8,14.1C187.7,37.6,183,39.5,177.5,39.5z
										 M177.5,34.7c4.1,0,7.7-1.4,10.6-4.3c2.9-2.9,4.3-6.5,4.3-10.6c0-4.1-1.4-7.7-4.3-10.6c-2.9-2.9-6.4-4.4-10.6-4.4
										c-4.1,0-7.7,1.4-10.6,4.4c-2.9,2.9-4.3,6.4-4.3,10.6c0,4.1,1.4,7.7,4.3,10.6C169.8,33.2,173.4,34.7,177.5,34.7z"></path>
								</g>
								<g>
									<path fill="#ffffff" d="M238.1,15.5v20.7c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5V15.5c0-6.7-3.7-10.6-10.3-10.6
										c-7.2,0-12.2,4.4-12.2,14v17.3c0,1.4-1.1,2.5-2.5,2.5l0,0c-1.4,0-2.5-1.1-2.5-2.5V3.4c0-1.4,1.1-2.5,2.5-2.5l0,0
										c1.4,0,2.5,1.1,2.5,2.5v1.2c0,0.7,0.8,0.9,1.2,0.4c2.7-3.4,6.6-5,11.4-5C232.4,0,238.1,6,238.1,15.5z"></path>
								</g>
							</g>
						</svg>
				    </a><!--logo-->
			    </div>
			    <div class="col-4 col-lg-5 text-right d-flex justify-content-end align-items-center">
				    <!--
				    <span class="search-trigger search-icon" @click="triggerSearch"></span>
				    -->
					<div v-if="user_organizations.length > 1" class="multi-org">
					 <div class="text-right">
					 			<div class="trigger-hidden-content ml-1 d-inline-block">
									<!-- New Actions section for password reset section -->
									<span class="text-right button">
										{{ user_active_organization }} <i class="fa fa-caret-down" aria-hidden="true" style="vertical-align: baseline"></i>
									</span>
									<div class="hidden-content hc-right-bottom"> 
										<div>
											<ul class="list-unstyled text-left">
												<template>
												<li  class="pb-2 pt-2 d-flex align-items-center 
														cursor-pointer color_black" v-for="(organization,index) in user_organizations" :key="index">
														<a @click="changeOrganization(organization)">
														<span class="organization_circle" :class="{'blue_circle' : user_active_organization == organization.name}" ></span>{{organization.name}}</a>
													

												</li>
													
											   </template>
											</ul>
										</div>
									</div>
							</div>
					 </div>

					</div>

				    <div v-else class="user-content" @click="triggerUserContent">
						
					<a>
						<!--
						<span class="thumb-container profile-thumb" :style="{'background-image': 'url('+image+')'}">
							<span class="notifications-count">0</span>
						</span>
						-->
						<span class="user-name no-dropdown">
							{{ user.name }} <span v-if="user.organization">| {{ user.organization }}</span>
						</span>
					</a>
					
					<div>
						<span class="close close-icon"></span>
						<!--
					    <div data-simplebar>
							<ul>
								
								<li>
									<a href="#">
										<span class="thumb-container" :style="{'background-image': 'url('+user.image+')'}"></span>
										<p><span class="orange">Peter Moskale</span> ha guardado “Sillón Mosaico”</p>
									</a>
								</li>
							</ul>
						</div>
						-->
						<ul>
							
							<li><router-link tag="a" class="settings-link" :to="{ name : 'profile' }"><span>Profile</span></router-link></li>
							<!-- <li @click="logout"><a class="logout-link" href="#" ><span>Log out</span></a></li> -->
						</ul>
					</div>
					
				</div><!--user_content-->
				<router-link v-if="user_organizations.length > 1"
				tag="a" class="settings-link mr-1" :to="{ name : 'profile' }">
				   <div class="cursor-pointer button d-flex height-22 dark_green justify-content-center align-items-center m-0 pr-2 pl-2" >
					   
					    <img width="12" class="ml-2" src="./../../assets/images/icon_settings_white.svg" />
					</div>
					</router-link>
				    
				    <div class="cursor-pointer button white-content d-flex height-22 justify-content-center align-items-center m-0 pr-2 pl-2" @click="logout">
					   
						<img width="12" class="ml-2" src="./../../assets/images/icons/solid/sign-out-alt_darkgreen.svg" />
					</div>
				 

				    <!--<div class="user-info relative custom-collapse right-collapse">
					    <div class="d-flex align-items-center">
						    <div class="trigger">
					    		<img src="assets/images/icon_person.png)" width="32" />
					    		<span class="notifications-count">2</span>
						    </div>
					    	<small class="trigger d-none d-sm-inline-block">Lorem Ipsum</small>
						</div>
				    	<div class="content">
					    	<ul class="green-content">
						    	<li>
						    		<a href="#">Profile</a>
						    	</li>
						    	<li>
						    		<a href="#">Profile</a>
						    	</li>
						    	<li>
						    		<a href="#">Profile</a>
						    	</li>
						    	<li>
						    		<a href="#">Logout</a>
						    	</li>
					    	</ul>
				    	</div>
				    </div>-->
			    </div><!--col-->
		    </div><!--row-->
		</div><!--container-->
	</header>
</div>
</template>

<script>
export default{

	data : function(){
		return {
			image : null,
			organizations : [],
			user_org:''
		}
	},
	computed : {
		isLogged : function(){
			return this.$store.getters.isLogged;
		},
		user : function(){
			this.image = null;
			this.image = this.$store.getters.getUser.image + '?param=true';
			return this.$store.getters.getUser;
		},
		user_organizations : function(){
			return this.$store.getters.getUserOrganizations
		},
		user_active_organization: {
			get: function(){
				return this.$store.getters.getCurrentOrganization
			},
			set: function(org){
				this.$store.commit('setUserCurrentOrganization', org)
			}
			
		}
	},
	methods : {
		logout : function(){
			this.$store.dispatch('logout', { router : this.$router });
			localStorage.clear();
		},

		triggerMenu : function(){
			this.$store.commit('setMenuActive');
		},

		triggerSearch : function(){
			this.$store.commit('setSearchActive');
		},

		triggerUserContent : function(){
			this.$store.commit('setUserContentActive');
		},
		changeOrganization: function(organization){
			if(organization.name == this.user_active_organization){
				return
			}
			var params = { 
				id: organization.id
			}
			this.$store.dispatch('changeUserOrganization', params).then((res) => {
				
				this.user_active_organization = res.data.organization.name
				// this.$router.go()
				
			}).catch((error) => {
				console.log(error)
			});

		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/shared/HeaderComponent.vue